<template>
  <v-row
    v-if="pickUpEvents.length"
    class="ma-0 px-2 px-md-4 px-lg-8"
    id="scrollToContact"
    dense
  >
    <v-col cols="12" md="8">
      <ItemGroup
        :items="computedPickUpAndDeliveryEvents"
        :wrap="true"
        :itemsPerRow="itemsPerRow"
      >
        <template v-slot:item="{ item }">
          <div class="mb-3 text-start text-break">
            <!-- Name -->
            <h3 class="mb-1 primary-font-color">
              {{
                item.EventTranslationName !== ''
                  ? item.EventTranslationName
                  : $translate('NO_NAME_AVAILABLE')
              }}
            </h3>

            <!-- address -->
            <div v-if="isPickUp(item)" class="ma-0 mb-1 primary-font-color">
              <!-- store icon -->
              <v-icon class="primary-font-color mr-1" style="float: left">
                store_mall_directory
              </v-icon>
              <!-- address -->
              <p class="mb-0">
                {{
                  item.Street !== ''
                    ? `${item.Street}  ${item.Nr} ${item.PostalCode} ${item.City}`
                    : $translate('NO_ADDRESS_AVAILABLE')
                }}
              </p>
            </div>
            <!-- email -->
            <p v-if="item.Email !== ''" class="mb-1 primary-font-color">
              <!-- email icon -->
              <v-icon class="primary-font-color">mdi-email</v-icon>
              <!-- email -->
              <a class="primary-font-color" :href="'mailto:' + item.Email">
                {{ item.Email }}
              </a>
            </p>
            <!-- phone number -->
            <p v-if="item.Telephone !== ''" class="mb-1">
              <!-- phone icon -->
              <v-icon class="primary-font-color">phone</v-icon>
              <!-- phone number -->
              <a class="primary-font-color" :href="'tel:' + item.Telephone">
                {{ item.Telephone }}
              </a>
            </p>
            <!-- opening hours -->
            <p v-if="isPickUp(item)" class="mb-1 primary-font-color">
              <!-- clock icon -->
              <v-icon class="primary-font-color">access_time</v-icon>
              <!-- opening hours -->
              {{
                item.OpeningHours !== ''
                  ? item.OpeningHours
                  : $translate('NO_OPENING_HOURS_AVAILABLE')
              }}
            </p>
            <template v-if="isDelivery(item)">
              <!-- Description for delivery event -->
              <div v-html="item.Description" class="primary-font-color mb-1" />

              <!-- included and excluded areas -->
              <p
                v-if="item.DeliveryAreas.length"
                class="mb-1 word-break-normal primary-font-color"
              >
                {{ $translate('INCLUDED_AREAS') }}<br />
                {{ convertArrayToString(item.DeliveryAreas) }}
              </p>
              <p
                v-if="item.DeliveryExcludedAreas.length"
                class="mb-1 primary-font-color word-break-normal"
              >
                {{ $translate('EXCLUDED_AREAS') }}<br />
                {{ convertArrayToString(item.DeliveryExcludedAreas) }}
              </p>
            </template>
          </div>
        </template>
      </ItemGroup>
    </v-col>

    <!-- Map -->
    <v-col cols="12" md="4">
      <v-card width="100%">
        <Map
          ref="homepageMap"
          :settings="mapSettings"
          @readyToInitializeMap="initializeHomepageMap"
        />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import doRequest from '@/api/dssRequest';
import MapObject from '@/objects/MapObject';
import Map from '@/components/generalComponents/map/Map.vue';
import ItemGroup from '@/components/generalComponents/uiComponents/ItemGroup';

export default {
  name: 'FooterContacts',
  components: {
    Map,
    ItemGroup,
  },
  data() {
    return {
      mapSettings: {
        name: 'footerMap',
        view: {
          zoom: 11,
        },
        interactions: {
          doubleClickZoom: true,
          dragAndDrop: true,
          dragPan: true,
          keyboardPan: true,
          keyboardZoom: false,
          mouseWheelZoom: true,
          pointer: true,
          select: true,
        },
        controls: {
          zoomControls: true,
          filterOption: false,
        },
        style: 'width: 100%; height: 300px;',
      },
      tab: null,
      model: null,
      pickUpEvents: [],
      types: ['PickUp', 'Innovend'],
    };
  },
  computed: {
    computedPickUpAndDeliveryEvents() {
      // to filter the events by type
      const pickUpEvents = [];
      const deliveryEvents = [];
      this.pickUpEvents.forEach((event) => {
        if (event.Type === 'Delivery' || event.Type === 'Shiplee') {
          deliveryEvents.push(event);
        } else {
          pickUpEvents.push(event);
        }
      });
      return pickUpEvents.concat(deliveryEvents);
    },
    itemsPerRow() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 1.2;
        case 'sm':
          return 2.5;
        case 'md':
          return 2;
        case 'lg':
          return 3;
        case 'xl':
        default:
          return 4;
      }
    },
  },
  mounted() {
    this.getPickUpAndDeliveryInfo();
  },
  created() {
    this.setPickUpEventsAreas();
  },
  methods: {
    convertArrayToString(array) {
      if (array == null) {
        return '';
      }
      return array.join(', ');
    },
    getPickUpAndDeliveryInfo() {
      const payload = {
        IncludeAllPartnersInPartnerGroup: true,
      };
      doRequest(
        (response) => {
          this.pickUpEvents = [];
          if (response.data.Events != null) {
            Object.entries(response.data.Events).forEach(([key, value]) =>
              this.pickUpEvents.push({ key, ...value })
            );
          }

          // Sort events
          this.pickUpEvents.sort((a, b) => {
            if (b.EventRanking > a.EventRanking) return 1;
            if (b.EventRanking < a.EventRanking) return -1;
            if (b.EventTranslationName > a.EventTranslationName) return -1;
            if (b.EventTranslationName < a.EventTranslationName) return 1;
            return 0;
          });
        },
        () => {},
        'getPickUpAndDeliveryInfo',
        'LocationsNode_ESE',
        payload,
        'GET'
      );
    },
    setPickUpEventsAreas() {
      this.pickUpEvents.forEach((event) => {
        event.inclAreaText = event.DeliveryAreas.join(', ');
        event.exclAreaText = event.DeliveryExcludedAreas.join(', ');
      });
    },
    initializeHomepageMap() {
      const homepageMap = this.$refs.homepageMap.map;
      homepageMap.deleteLayer('homePage');
      const features = [];
      const focusLine = [];
      this.pickUpEvents.forEach((marker) => {
        features.push(
          MapObject.createCategoryMarker({
            longitude: marker.Longitude,
            latitude: marker.Latitude,
            category: require('@/assets/Destination-states/categories/Pickup-point.png'),
            data: { locationId: marker.LocationId },
          })
        );
        focusLine.push([marker.Longitude, marker.Latitude]);
      });
      // the timeout is used becaue the map centerpoint is later than the focusOnPolyline
      setTimeout(() => {
        homepageMap.focusOnPolyline(focusLine, [50, 50, 50, 50]);
      }, 0);
      const vectorSource = MapObject.createVectorSource(features);
      const vectorLayer = MapObject.createVectorLayer('homePage', vectorSource);
      vectorLayer.setZIndex(100);
      homepageMap.addLayerOnMap(vectorLayer);
    },
    isDelivery(event) {
      return (
        event != null && (event.Type === 'Delivery' || event.Type === 'Shiplee')
      );
    },
    isPickUp(event) {
      return (
        event != null && (event.Type === 'PickUp' || event.Type === 'Innovend')
      );
    },
  },
};
</script>
